import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
// import Autosuggest from 'react-autosuggest';

import { fetchZipCodes, fetchAnalytics, userLogout } from "../Actions";
import UploadDialog from "./Dialogues/UploadDialog";
import ExportDataDialog from "./Dialogues/ExportDataDialog";
import logo from "../Assets/images/Swaasa.png";
import apollo from "../Assets/images/apollo.png";
// import searchIcon from '../Assets/images/sidebar/search.svg';
import aiIcon from "../Assets/images/sidebar/ai.svg";
import axios from "../axios";
// import { MdClose } from "react-icons/md";
// import { FiMenu } from "react-icons/fi";
import { slide as Menu } from "react-burger-menu";
import env from "react-dotenv";
// import fs from "fs";

const SideBar = (props) => {
  // const [value, setValue] = useState('');
  // const [suggestions, setSuggestions] = useState([]);
  // const [searchError, setSearchError] = useState(false);
  const [open, setOpen] = useState(false);
  const [openExport, setOpenExport] = useState(false);
  // useEffect(() => {
  //   props.fetchZipCodes();
  // }, []);

  // useEffect(() => {
  //   if (localStorage.zip && value === '') {
  //     setValue(localStorage.zip);
  //   }
  // }, [props.zipCodes]);

  useEffect(() => {
    //    props.fetchAnalytics();
  }, []);

  console.log(localStorage.doctorId);

  const logout = () => {
    props.userLogout();
    localStorage.clear();
    props.history.push("/");
  };
const handleClose = () => {
  setOpen(false);
}
const handleCloseExport = () => {
  setOpenExport(false);
}
  const exportData = () => {
    axios
      .get(`/export-data/${localStorage.adminId}`, {
        headers: { accessToken: localStorage.accessToken },
        responseType: "blob",
      })
      .then((response) => {
        console.log(response);
      console.log(response.data)
      console.log(typeof(response.data),"yrthff7");
      var today = new Date();
  var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
      const fileName = localStorage.doctorId + "-(" + date +').xlsx'
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
  };

  const exportApolloData = () => {
    axios
      .get(`/export-executive-data?doctorId=${encodeURIComponent(localStorage.doctorId)}`, {
        headers: { accessToken: localStorage.accessToken },
        responseType: "blob",
      })
      .then((response) => {
        console.log(response);
        console.log(response.data)
        var today = new Date();
  var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
        const fileName = localStorage.doctorId + "-(" + date +').xlsx'
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', fileName); //or any other extension
          document.body.appendChild(link);
          link.click();
      });
  };

  // const onSearch = () => {
  //   setSearchError(false);
  //   if (props.zipCodes.indexOf(value) > -1) {
  //     localStorage.zip = value;
  //     props.fetchAnalytics();
  //   } else {
  //     setSearchError(true);
  //   }
  // };

  // AutoSuggest Methods

  // const getSuggestions = (value) => {
  //   const inputValue = value.trim();
  //   const inputLength = inputValue.length;

  //   return inputLength === 0
  //     ? []
  //     : props.zipCodes.filter(
  //         (zip) => zip.slice(0, inputLength) === inputValue
  //       );
  // };

  // const onSuggestionsChange = (event, { newValue }) => {
  //   setValue(newValue);
  // };

  // const onSuggestionsFetchRequested = ({ value }) => {
  //   setSuggestions(getSuggestions(value));
  // };

  // const onSuggestionsClearRequested = () => {
  //   setSuggestions([]);
  // };

  // const getSuggestionValue = (suggestion) => suggestion;

  // const onSuggestionSelected = (event, { suggestionValue }) => {
  //   setSearchError(false);
  //   localStorage.zip = suggestionValue;
  //   props.fetchAnalytics();
  // };

  // const renderSuggestion = (suggestion) => (
  //   <div className="render-suggestion">{suggestion}</div>
  // );

  // Styles

  const selectedItem = {
    borderColor: "#1ad94740",
    boxShadow: "0 0 2px 0 #1ad947",
  };

  const selectedItemDot = {
    borderColor: "#1ad947",
    backgroundColor: "#1ad947",
  };

  const [navbarOpen, setNavbarOpen] = useState(false);
  const handleToggle = () => {
    setNavbarOpen(!navbarOpen);
  };

  const [width, setWidth] = React.useState(window.innerWidth);
  const breakpoint = 1000;
  React.useEffect(() => {
    const handleResizeWindow = () => setWidth(window.innerWidth);
    // subscribe to window resize event "onComponentDidMount"
    window.addEventListener("resize", handleResizeWindow);
    return () => {
      // unsubscribe "onComponentDestroy"
      window.removeEventListener("resize", handleResizeWindow);
    };
  }, []);

  if (width > breakpoint) {
    return (
      <div
        className="sidebar"
        style={{
          display: "grid",
          overflow: "scroll",
          "grid-template-row": "auto auto 1fr auto",
        }}
      >
        {localStorage.adminId == "admin@apollo.com" ? (
          <div className="sidebar__apollo">
            <img src={apollo} alt="logo" />
          </div>
        ) : (
          <div className="sidebar__logo">
            <img src={logo} alt="logo" />
          </div>
        )}

        {/* <div className="sidebar__user">
          <p>Medical Practitioner</p>
        </div> */}
        <div className="sidebar__menu">
          {/* <div className="sidebar__menu__zip">
            <Autosuggest
              suggestions={suggestions}
              onSuggestionsFetchRequested={onSuggestionsFetchRequested}
              onSuggestionsClearRequested={onSuggestionsClearRequested}
              getSuggestionValue={getSuggestionValue}
              renderSuggestion={renderSuggestion}
              inputProps={{
                value: typeof value !== 'undefined' ? value : '',
                onChange: onSuggestionsChange,
              }}
              onSuggestionSelected={onSuggestionSelected}
            />
            <button onClick={onSearch}>
              <img src={searchIcon} alt="search" />
            </button>
          </div>
          <div className="sidebar__search-error">
            {searchError && <p>Area not found</p>}
          </div> */}

          <button
            onClick={() => {
              props.history.push(`/patients`);
            }}
            className="sidebar__menu__item"
            style={props.patients ? selectedItem : {}}
          >
            <div style={props.patients ? selectedItemDot : {}} />
            <p style={props.patients ? { color: "#1ad947" } : {}}>Patients</p>
          </button>
          {localStorage.validation != "true" ||
          localStorage.longitudinal_study == "true" ? (
            <>
              <button
                onClick={() => {
                  props.history.push("/home");
                }}
                className="sidebar__menu__item"
                style={props.home ? selectedItem : {}}
              >
                <div style={props.home ? selectedItemDot : {}} />
                <p style={props.home ? { color: "#1ad947" } : {}}>Analytics</p>
              </button>
              <button
                onClick={() => {
                  props.history.push(`/assessments`);
                }}
                className="sidebar__menu__item"
                style={props.assessments ? selectedItem : {}}
              >
                <div style={props.assessments ? selectedItemDot : {}} />
                <p style={props.assessments ? { color: "#1ad947" } : {}}>
                  Assessments
                </p>
              </button>
            </>
          ) : (
            <div></div>
          )}
          {localStorage.bulkupload == "true"  && (<button
            onClick={() => {
              setOpen(true);
            }}
            className="sidebar__menu__item"
          >
            <p>Upload</p>
          </button>)}
        </div>

        <UploadDialog open={open}
         handleClose={(data) =>
         handleClose()
        } ></UploadDialog>

        <ExportDataDialog openExport={openExport}
        handleCloseExport = {(data) => handleCloseExport()}
        ></ExportDataDialog>

     
        {
          <div
            className={localStorage.export_data == "true" ? "" : "hideMe"}
            style={{ margin: "10px" }}
            onClick={() => {
              setOpenExport(true);
            }}
          >
            <div className="exports"> Export Data</div>
          </div>
        }

        <div className="sidebar__footer">
          <button className="sidebarid">{localStorage.doctorId}</button>
          <button
            onClick={() => {
              logout();
            }}
            className="sidebar__footer__logout-btn"
          >
            LOGOUT
          </button>
          <div className="sidebar__footer__brand">
            <div className="sidebar__footer__brand__content">
              <p className="sidebar__footer__brand__title">Powered by</p>
              <p className="sidebar__footer__brand__subtitle">Swaasa.AI</p>

              <p className="sidebar__footer__brand__appversion">
                Swaasa AI Platform {process.env.REACT_APP_SWAASA_VERSION}
              </p>
              <p className="sidebar__footer__brand__appversion">
                Dashboard {process.env.REACT_APP_VERSION}
              </p>
            </div>
            <img
              className="sidebar__footer__brand__img"
              src={aiIcon}
              alt="AI"
            />
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <Menu>
        <div className="sidebar">
          {localStorage.adminId == "admin@apollo.com" ? (
            <div className="sidebar__apollo">
              <img src={apollo} alt="logo" />
            </div>
          ) : (
            <div className="sidebar__logo">
              <img src={logo} alt="logo" />
            </div>
          )}
          <div className="sidebar__menu">
            <button
              onClick={() => {
                props.history.push(`/patients`);
              }}
              className="sidebar__menu__item"
              style={props.patients ? selectedItem : {}}
            >
              <div style={props.patients ? selectedItemDot : {}} />
              <p style={props.patients ? { color: "#1ad947" } : {}}>Patients</p>
            </button>
            {localStorage.validation != "true" ||
            localStorage.longitudinal_study == "true" ? (
              <button
                onClick={() => {
                  props.history.push("/home");
                }}
                className="sidebar__menu__item"
                style={props.home ? selectedItem : {}}
              >
                <div style={props.home ? selectedItemDot : {}} />
                <p style={props.home ? { color: "#1ad947" } : {}}>Analytics</p>
              </button>
            ) : (
              <div></div>
            )}
            <button
              onClick={() => {
                props.history.push(`/assessments`);
              }}
              className="sidebar__menu__item"
              style={props.assessments ? selectedItem : {}}
            >
              <div style={props.assessments ? selectedItemDot : {}} />
              <p style={props.assessments ? { color: "#1ad947" } : {}}>
                Assessments
              </p>
            </button>
            
          </div>
          {/* {
          <div
            className={localStorage.validation == "true"  ? "" : "hideMe"}
            style={{ margin: "10px" }}
            onClick={exportData}
          >
            <div className="exports"> Export Data</div>
          </div>
        } */}
        <ExportDataDialog openExport={openExport}
        handleCloseExport = {(data) => handleCloseExport()}
        ></ExportDataDialog>

     
        {
          <div
            className={localStorage.export_data == "true" ? "" : "hideMe"}
            style={{ margin: "10px" }}
            onClick={() => {
              setOpenExport(true);
            }}
          >
            <div className="exports"> Export Data</div>
          </div>
        }

          <div className="sidebar__footer">
            <button className="sidebarid">{localStorage.doctorId}</button>
            <button
              onClick={() => {
                logout();
              }}
              className="sidebar__footer__logout-btn"
            >
              LOGOUT
            </button>
            <div className="sidebar__footer__brand">
              <div className="sidebar__footer__brand__content">
                <p className="sidebar__footer__brand__title">Powered by</p>
                <p className="sidebar__footer__brand__subtitle">Swaasa.AI</p>
                <p className="sidebar__footer__brand__appversion">
                  Swaasa AI Platform {process.env.REACT_APP_SWAASA_VERSION}
                </p>
                <p className="sidebar__footer__brand__appversion">
                  Dashboard {process.env.REACT_APP_VERSION}
                </p>
              </div>
              <img
                className="sidebar__footer__brand__img"
                src={aiIcon}
                alt="AI"
              />
            </div>
          </div>
        </div>
      </Menu>
    );
  }
};

const mapStateToProps = (state) => ({
  isFetchingZip: state.zipCodes.isFetching,
  zipCodes: state.zipCodes.list,
  isFetchingAnalytics: state.analytics.isFetching,
});

export default withRouter(
  connect(mapStateToProps, { fetchZipCodes, fetchAnalytics, userLogout })(
    SideBar
  )
);
